import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    appointments:[]
  }),
  mutations: {
    SET_APPOINTMENTS(state, items) {
      state.appointments = items
    }
  },
  actions: {
    async fetchAppointments({ commit }, data) {
      const res = await apiClient('appointments.get', data)
      commit('SET_APPOINTMENTS', res.list)
    },
    async saveAppointment({ commit }, scheduleData) {
      const res = await apiClient('appointments.create', scheduleData)
      commit('SET_APPOINTMENTS', res.list)
    },
    async updateAppointment({ commit }, scheduleData) {
      const res = await apiClient('appointments.update', scheduleData)
      commit('SET_APPOINTMENTS', res.list)
    },
    async deleteAppointment({ commit }, data) {
      const res = await apiClient('appointments.delete', data)
      commit('SET_APPOINTMENTS', res.list)
    },
    async statusAppointment({ commit }, data) {
      const res = await apiClient('appointments.status', data)
      commit('SET_APPOINTMENTS', res.list)
    },
    async closeAppointment({ commit }, data) {
      const res = await apiClient('appointments.close', data)
      commit('SET_APPOINTMENTS', res.list)
    },
    async cancelCompletion({ commit }, data) {
      const res = await apiClient('appointments.cancel', data)
      commit('SET_APPOINTMENTS', res.list)
    }
  }
}
